import { LegalEntitiesRollbacksService_rollbackServicePostFrame } from '@festina/legalentity-general-types/legalentity/hooks/LegalEntitiesRollbacksService_rollbackServicePostFrame'

export const useFetchRollbackFrame =
  LegalEntitiesRollbacksService_rollbackServicePostFrame.useSuspenseQuery
